import { RefreshTokenException } from '@/domain/authenticating/authorization/exception/RefreshTokenException'

export class UnauthorizedException extends RefreshTokenException {

}
